import * as React from 'react';
/**
 * SideNav context.
 */
export interface ISideNavContext {
  /**
   * The label of the currently active Item.
   */
  activeItem: string;

  /**
   * Sets active Item.
   */
  setActiveItem: (label: string) => void;

  /**
   * Expands all sub navs if true
   */
  allExpanded?: boolean;

  /**
   * Expands sub navs within list
   */
  expanded?: string[];
  iconOnlyMode?: boolean;
  onOpenChange?: (navKey: string) => void;
}

export const SideNavContext = React.createContext<ISideNavContext | undefined>(
  undefined
);

/**
 * Hook which exposes parts of the `ISideNavContext` for state
 * consumption.
 */
export const useNavContext = (): ISideNavContext => {
  const context = React.useContext(SideNavContext);
  if (!context) {
    throw new Error(
      'This component must be used within a <SideNav> component.'
    );
  }
  return context;
};
